import { createFileRoute } from "@tanstack/react-router";
import { ProductAnalyticsSessionsListPage } from "../../../../components/system/ProductAnalyticsSessionsListPage";
import { requireSuperAdmin } from "../../../../lib/auth/route-protection";

export const Route = createFileRoute("/system/product-analytics/sessions/")({
  beforeLoad: requireSuperAdmin(),
  component: ProductAnalyticsSessionsListPage,
});
